import { CheckIcon } from "@heroicons/react/24/outline";

type ValueItem = {
  description: string;
  iconClassName: string;
  title: string;
};

const VALUE_ITEMS: ValueItem[] = [
  {
    description: "AI-driven browser interactions to test your application",
    iconClassName: "bg-green-100 text-green-600",
    title: "Automated UX Testing",
  },
  {
    description: "Surfaces backlog-worthy issues that hurt task success, trust, or recovery",
    iconClassName: "bg-blue-100 text-blue-600",
    title: "Impact-first usability analysis",
  },
  {
    description: "Get specific recommendations to improve user experience",
    iconClassName: "bg-purple-100 text-purple-600",
    title: "Actionable Insights",
  },
];

export default function ValuePropositions() {
  return (
    <div className="card mb-8 rounded-xl border border-gray-100 shadow-sm" data-testid="value-propositions">
      <div className="card-body space-y-4">
        {VALUE_ITEMS.map((item) => (
          <div key={item.title} className="flex items-start gap-3">
            <div
              className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full ${item.iconClassName}`}
            >
              <CheckIcon className="h-4 w-4" aria-hidden="true" />
            </div>
            <div className="text-left">
              <h3 className="mb-1 text-sm font-semibold text-gray-900">{item.title}</h3>
              <p className="text-sm text-gray-600">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
